module.exports = __webpack_public_path__ + "static/media/workPvcCeilings11.4cfbd092.jpg";